<template>
  <div class="tw-z-[11000] tw-opacity-80 tw-top-0 tw-left-0 tw-fixed tw-h-full tw-w-full tw-bg-whitesmoke">
    <div class="tw-flex tw-justify-center tw-relative tw-text-base tw-w-auto tw-h-12 tw-top-[40%]">
      <img alt="loader" :src="require('@/assets/images/loader.gif')">
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader"
}
</script>